import React from 'react'
import Portal from 'components/Portal/Portal'
import { Modal, ConfirmDialog } from '../Modal/Modal'
import PropTypes from 'prop-types'
import BankIcon from '@tecuity/sos-icons/react/bank-solid'
import CreditCardIcon from '@tecuity/sos-icons/react/credit-card-solid'
// import TrashIcon from '@tecuity/sos-icons/react/trash'
import { GET_PAYROC_CUSTOMER, DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE, CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE } from 'requests'
// import { Spinner } from '../Loaders/Loaders'
import useItransact from '../SavedPayments/useItransact'
import PlusIcon from '@tecuity/sos-icons/react/plus-heavy'
import TrashIcon from '@tecuity/sos-icons/react/trash'
import { useAppSetting } from '../../Utilities/hooks'
import './PayrocGenericModal.scss'

const PayrocGenericModal = ({
  title = 'Payment',
  instructions = '',
  isOpen = false,
  onRequestClose,
  onPaymentSelected
}) => {
  const [modalIsOpen, setModalIsOpen] = React.useState(false)
  const [customer, setCustomer] = React.useState(null)
  const [deletingId, setDeletingId] = React.useState(null)
  const [addingPaymentMethod, setAddingPaymentMethod] = React.useState(false)
  const iTransactIsLoaded = useItransact()
  const apiUsername = useAppSetting('PAYROC_API_USERNAME')
  const achEnabled = useAppSetting('PAYROC_ACH_ENABLED_YN')
  const modal = React.useRef();

  React.useEffect(
    () => {
      if (isOpen === true) {
        setModalIsOpen(true)
      } else if(modalIsOpen) {
        modal.current.closeModal(() => {
          setModalIsOpen(false);
        });
      }
    },
    [isOpen]
  )

  const getCustomer = () => {
    GET_PAYROC_CUSTOMER(customer => {
      if (customer) setCustomer(customer)
    }, console.error)
  }

  React.useEffect(() => {
    getCustomer()
  }, [])

  const openItransact = () => {
    const handler = window.iTransact.Checkout.init({
      apiUsername: apiUsername.setting.VALUE,
      name: 'Add new payment method',
      description: '',
      panelButtonText: 'Add method',
      billingAddress: true,
      ach: achEnabled.setting.VALUE,
      onToken: ({ token }, args) => {
        setAddingPaymentMethod(true)
        CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE(
          {
            token: token,
            address: args
          },
          success => {
            if(success){
              getCustomer()
            }
            onPaymentSelected(token)
            setAddingPaymentMethod(false)
          },
          err => {
            console.error(err)
            setAddingPaymentMethod(false)
          }
        )
      }
    })
    handler.render({
      amount: 0
    })
  }

  const startPaymentDelete = paySourceNum => {
    setDeletingId(paySourceNum)
  }

  const deletePaymentMethod = paySourceNum => {
    let cachedMethods = null
    setCustomer(customer => {
      cachedMethods = [...customer.payment_sources.map(x => ({ ...x }))]
      const toDeleteIndex = customer.payment_sources.findIndex(x => x.id === paySourceNum)
      return {
        ...customer,
        payment_sources: [
          ...customer.payment_sources.slice(0, toDeleteIndex),
          ...customer.payment_sources.slice(toDeleteIndex + 1)
        ]
      }
    })
    DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE(
      deletingId,
      () => {},
      err => {
        console.error(err)
        setCustomer(customer => ({
          ...customer,
          payment_sources: cachedMethods
        }))
      }
    )
  }

  return (
    <React.Fragment>
      <Portal isOpened={modalIsOpen}>
        <Modal
          title={title}
          closeModal={() => {
            setModalIsOpen(false)
            if (onRequestClose) onRequestClose()
          }}
          modalSize="small"
          closeButton
          autoHeight
          ref={modal}
        >
          {customer && iTransactIsLoaded && !apiUsername.loading && !achEnabled.loading && (
            <div className="itransact-checkout generic-itransact">
              {instructions ? <p className="instructions">{instructions}</p> : null}
              {customer.payment_sources.map(source => (
                <div className="payment-source" key={source.id}>
                  <button
                    className="btn btn-neutral select-button"
                    onClick={() => onPaymentSelected(source.id)}
                  >
                    Select
                  </button>
                  {source.type === 'ach' ? (
                    <span className="label-wrapper">
                      <BankIcon />
                      {`${source.savings_account === 'true' ? 'Savings' : 'Checking'} ****${
                        source.last_four_digits
                      }`}
                      <button
                        className="btn btn-solid btn-neutral delete-method-button"
                        type="button"
                        onClick={() => startPaymentDelete(source.id)}
                      >
                        <TrashIcon />
                      </button>
                    </span>
                  ) : (
                    <span className="label-wrapper">
                      <CreditCardIcon alt='Credit Card icon' />
                      {`${source.brand.charAt(0).toUpperCase() + source.brand.slice(1)} ****${
                        source.last_four_digits
                      }`}
                      <button
                        className="btn btn-solid btn-neutral delete-method-button"
                        type="button"
                        onClick={() => startPaymentDelete(source.id)}
                      >
                        <TrashIcon />
                      </button>
                    </span>
                  )}
                </div>
              ))}
              <button
                type="button"
                className="btn btn-solid btn-neutral add-button"
                onClick={openItransact}
                disabled={addingPaymentMethod}
              >
                <div className="flex-center">
                  <React.Fragment>
                    <PlusIcon /> {addingPaymentMethod ? 'Adding Payment Method' : 'Add New Payment Method' }
                  </React.Fragment>
                </div>
              </button>
            </div>
          )}
        </Modal>
      </Portal>
      <Portal isOpened={!!deletingId}>
        <ConfirmDialog
          closeModal={() => setDeletingId(null)}
          onModalClosed={() => {}}
          message="Are you sure you want to delete this payment method? Any active subscriptions using this payment method will be canceled. This cannot be undone."
          buttons={[
            { label: 'No', onClick: () => {}, className: 'btn-default' },
            {
              label: 'Yes',
              onClick: () => deletePaymentMethod(deletingId),
              className: 'btn-danger'
            }
          ]}
          modalStyle={{ borderRadius: 3 }}
        />
      </Portal>
    </React.Fragment>
  )
}
PayrocGenericModal.propTypes = {
  title: PropTypes.string,
  instructions: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  onPaymentSelected: PropTypes.func.isRequired
}

export default PayrocGenericModal



// WEBPACK FOOTER //
// ./src/components/Payroc/PayrocGenericModal.js